var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-richText"},[_vm._m(0),_c('div',{staticClass:"edit-shop-content"},[_c('section',{staticClass:"edit-shop-richText edit-intro-custom"},[_c('Wang-edit',{attrs:{"txt":_vm.content.text,"callback":_vm.setContent}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-shop-header"},[_c('h3',[_vm._v("富文本设置")]),_c('div',{staticClass:"edit-shop-delete"})])
}]

export { render, staticRenderFns }